import type React from 'react';
import { Licence } from '@seek/profile-read-ui';
import { Box, Stack } from 'braid-design-system';

interface Props {
  licences: Array<React.ComponentProps<typeof Licence>>;
}

const Licences = ({ licences }: Props) => (
  <Stack component="ul" space="large">
    {licences.map((licence) => (
      <Box key={licence.id}>
        <Licence {...licence} />
      </Box>
    ))}
  </Stack>
);
export default Licences;
